"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandbyActivities = void 0;
const react_1 = __importStar(require("react"));
const i18n_1 = require("@app/util/i18n");
const moment_1 = __importDefault(require("moment"));
const _ui_1 = require("@ui");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const StandbyActivities = ({ details, state, setState, disabled }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'ds-viewshift-row' },
            react_1.default.createElement("div", { className: 'ds-viewshift-col-label', style: { width: 'unset', maxWidth: 'unset' } }, (0, i18n_1.t)('SHIFT_STANDBY_SECTION'))),
        react_1.default.createElement("div", { className: 'ds-viewshift-row' },
            react_1.default.createElement(_ui_1.Flex, { direction: _ui_1.Flex.DIRECTION.COLUMN },
                react_1.default.createElement("table", { className: 'ds-viewshift-standby-table' },
                    react_1.default.createElement("tbody", null, state.standByActivities.map((_, idx) => {
                        const act = {
                            start: (0, moment_1.default)(details.period.start).clone().add(state.standByActivities[idx].start, 'minutes'),
                            end: (0, moment_1.default)(details.period.start).clone().add(state.standByActivities[idx].start + state.standByActivities[idx].duration, 'minutes'),
                        };
                        return (react_1.default.createElement(react_1.Fragment, { key: 'sa_' + idx.toString() },
                            react_1.default.createElement("tr", { key: 'sbact_' + idx.toString() },
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(_ui_1.Input, { size: _ui_1.Input.SIZES.LEAN, type: 'time', required: true, label: null, onChange: (val) => {
                                            const newActivities = ([...state.standByActivities] || []).map((ag, j) => {
                                                if (j === idx) {
                                                    let startMoment = (0, moment_1.default)((0, moment_1.default)(details.period.start).format('YYYY-MM-DD') + ' ' + val, 'YYYY-MM-DD HH:mm');
                                                    if (startMoment.isBefore(details.period.start))
                                                        startMoment = startMoment.clone().add(1, 'day');
                                                    return Object.assign({}, ag, { duration: ag.duration, start: startMoment.diff(details.period.start, 'minutes') });
                                                }
                                                else {
                                                    return ag;
                                                }
                                            });
                                            setState(s => Object.assign({}, s, { standByActivities: newActivities }));
                                        }, value: (0, moment_1.default)(act.start).format('HH:mm'), hasError: (act.end.isSameOrBefore(act.start) ||
                                            act.start.isBefore(details.period.start) ||
                                            act.start.isSameOrAfter(details.period.end)), disabled: disabled })),
                                react_1.default.createElement("td", null,
                                    react_1.default.createElement(_ui_1.Input, { size: _ui_1.Input.SIZES.LEAN, type: 'time', required: true, label: null, onChange: (val) => {
                                            const newActivities = ([...state.standByActivities] || []).map((ag, j) => {
                                                if (j === idx) {
                                                    const endMoment = (0, moment_1.default)((0, moment_1.default)(details.period.start).format('YYYY-MM-DD') + ' ' + val, 'YYYY-MM-DD HH:mm');
                                                    let newDuration = endMoment.diff(details.period.start, 'minutes') - ag.start;
                                                    if (newDuration <= 0)
                                                        newDuration += 1440;
                                                    if (newDuration > 1440)
                                                        newDuration -= 1440;
                                                    return Object.assign({}, ag, { duration: newDuration, start: ag.start });
                                                }
                                                else {
                                                    return ag;
                                                }
                                            });
                                            setState(s => Object.assign({}, s, { standByActivities: newActivities }));
                                        }, value: act.end.format('HH:mm'), hasError: (act.end.isSameOrBefore(state.standByActivities[idx].start) ||
                                            act.end.isSameOrBefore(details.period.start) ||
                                            act.end.isAfter(details.period.end)), disabled: disabled })),
                                react_1.default.createElement("td", null, !disabled ? (react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.delete, color: _ui_1.Icon.COLORS.RED, onClick: () => {
                                        const newActivities = state.standByActivities.filter((_, j) => j !== idx);
                                        setState(s => Object.assign({}, s, { standByActivities: newActivities }));
                                    } })) : null)),
                            react_1.default.createElement("tr", { key: 'sbactnote_' + idx.toString() },
                                react_1.default.createElement("td", { colSpan: 3 },
                                    react_1.default.createElement(_ui_1.Input, { size: _ui_1.Input.SIZES.SMALL, label: null, type: _ui_1.Input.TYPES.TEXT, placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, i18n_1.t)('VIEW_SHIFT_TYPE_NOTE')), onChange: (v) => {
                                            const newActivities = [...state.standByActivities] || [];
                                            newActivities[idx] = Object.assign({}, newActivities[idx], {
                                                note: v,
                                            });
                                            setState(s => Object.assign({}, s, { standByActivities: newActivities }));
                                        }, value: state.standByActivities[idx].note, disabled: disabled }),
                                    react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_8 })))));
                    }))),
                !disabled ? (react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_8 },
                    react_1.default.createElement("span", { className: 'ds-link', onClick: () => {
                            let latestActivityEnd = 0;
                            state.standByActivities.forEach(act => {
                                if (act.start + act.duration > latestActivityEnd) {
                                    latestActivityEnd = act.start + act.duration;
                                }
                            });
                            const newActivities = [...state.standByActivities] || [];
                            newActivities.push({
                                start: latestActivityEnd,
                                duration: 60,
                            });
                            setState(s => Object.assign({}, s, { standByActivities: newActivities }));
                        } }, '+ ' + (0, i18n_1.t)('SHIFT_STANDBY_ADD_ACTIVITY')))) : null))));
};
exports.StandbyActivities = StandbyActivities;
